import { createContext, useContext } from 'react';
import Axios, { AxiosInstance } from 'axios';

export const Http = createContext<AxiosInstance>(Axios);

export function useHttp() {
    return useContext(Http);
}
